import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const DEFAULT_DESIGNATIONS = [
    "Jr. Account Executive",
    "Account Executive",
    "Senior Account Executive",
    "Accountant",
    "Senior Accountant",
    "Assistant Manager",
    "Manager",
    "Senior Manager",
    "Director",
];

const DesignationSelect = ({
    value,
    onChange,
    label = "Designation",
    extraOptions = [],
    ...props
}) => {

    const finalOptions = [...extraOptions, ...DEFAULT_DESIGNATIONS];

    return (
        <FormControl fullWidth {...props}>
            <InputLabel id="designation-label">{label}</InputLabel>
            <Select
                labelId="designation-label"
                label={label}
                value={value || ""}
                onChange={onChange}
            >
                {finalOptions.map((designation) => (
                    <MenuItem key={designation} value={designation}>
                        {designation}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default DesignationSelect;